<app-breadcrumb
	[title]="t('امتدادات توكنات التحليل', 'Analysis token extensions', 'הרחבות טוקן ניתוח')"
	[items]="[t('لوحة التحكم', 'Dashboard', 'לוח בקרה')]"
	[active_item]="t('امتدادات التوكنات', 'Token extensions', 'הרחבות טוקנים')"
></app-breadcrumb>

<div class="container-fluid basic_table">
	<div class="card mb-3">
		<div class="card-header d-flex justify-content-between flex-wrap gap-2">
			<h5 class="mb-0">{{ t('امتدادات توكنات تحليل المصاريف', 'Expense analysis token extensions', 'הרחבות טוקן ניתוח הוצאות') }}</h5>
			<div class="d-flex gap-2">
				<button class="btn btn-dark" type="button" (click)="openCreateTokenExtensionModal(subscriptionModal)">
					<i class="fa fa-plus mx-1"></i>{{ t('منح امتداد لتاجر', 'Grant extension to merchant', 'הענקת הרחבה לסוחר') }}
				</button>
				<button class="btn btn-outline-secondary" (click)="goBack()">
					<i class="fa fa-arrow-left mx-1"></i>{{ t('العودة', 'Back', 'חזרה') }}
				</button>
				<button class="btn btn-outline-warning" (click)="loadPlans()">
					<i class="fa fa-refresh mx-1"></i>{{ t('تحديث', 'Refresh', 'רענון') }}
				</button>
			</div>
		</div>

		<div class="card-body">
			<div class="row g-3">
				<div class="col-12">
					<div class="card inner-card">
						<div class="card-body">
							<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
								<div class="row flex-grow-1">
									<div class="col-md-6">
										<label class="form-label">{{ t('بحث', 'Search', 'חיפוש') }}</label>
										<input class="form-control" [(ngModel)]="planSearch" [ngModelOptions]="{standalone:true}" />
									</div>
								</div>
								<button class="btn btn-dark" (click)="openCreatePlanModal(planModal)">
									<i class="fa fa-plus-circle mx-1"></i>{{ t('إنشاء خطة امتداد', 'Create extension plan', 'יצירת תוכנית הרחבה') }}
								</button>
							</div>

							<div class="table-responsive">
								<table class="table table-bordered table-hover text-center align-middle">
									<thead class="table-light">
										<tr>
											<th>#</th>
											<th>{{ t('الاسم', 'Name', 'שם') }}</th>
											<th>{{ t('التوكنات', 'Tokens', 'טוקנים') }}</th>
											<th>{{ t('السعر', 'Price', 'מחיר') }}</th>
											<th>{{ t('الحالة', 'Active', 'פעיל') }}</th>
											<th>{{ t('الترتيب', 'Sort', 'סדר') }}</th>
											<th>{{ t('الإجراءات', 'Actions', 'פעולות') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let p of filteredPlans; let i = index">
											<td>{{ i + 1 }}</td>
											<td>{{ getPlanDisplayName(p) }}</td>
											<td>{{ p.extra_tokens ?? p.documents_count ?? '—' }}</td>
											<td>{{ p.price }}</td>
											<td><span class="badge" [ngClass]="p.is_active ? 'bg-success' : 'bg-danger'">{{ p.is_active ? t('نعم','Yes','כן') : t('لا','No','לא') }}</span></td>
											<td>{{ p.sort_order }}</td>
											<td>
												<button class="btn btn-sm btn-outline-primary me-1" (click)="openEditPlanModal(planModal, p)"><i class="fa fa-edit"></i></button>
												<button class="btn btn-sm btn-outline-danger" (click)="deletePlan(p.id)"><i class="fa fa-trash"></i></button>
											</td>
										</tr>
										<tr *ngIf="filteredPlans.length === 0">
											<td colspan="7" class="text-muted">{{ t('لا توجد خطط', 'No plans found', 'לא נמצאו תוכניות') }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12 mb-3" *ngIf="lastPaymentUrl">
				<div class="payment-link-box">
					<label class="form-label mb-1">
						{{ t('آخر رابط دفع', 'Last Payment Link', 'קישור תשלום אחרון') }}
						<span *ngIf="lastOrderId"> - {{ t('رقم الطلب', 'Order ID', 'מספר הזמנה') }}: {{ lastOrderId }}</span>
					</label>
					<div class="input-group">
						<input class="form-control" [value]="lastPaymentUrl" readonly />
						<button class="btn btn-outline-primary" type="button" (click)="copyPaymentLink()">
							<i class="fa fa-copy mx-1"></i>{{ t('نسخ', 'Copy', 'העתק') }}
						</button>
						<a class="btn btn-outline-dark" [href]="lastPaymentUrl" target="_blank" rel="noopener noreferrer">
							<i class="fa fa-external-link mx-1"></i>{{ t('فتح', 'Open', 'פתח') }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #subscriptionModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">{{ t('منح امتداد توكنات لتاجر', 'Grant token extension to merchant', 'הענקת הרחבת טוקנים לסוחר') }}</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="subscriptionForm" class="row g-3 mt-1">
			<div class="col-md-6">
				<label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
				<ng-select
					[items]="merchantOptions"
					bindLabel="display_label"
					bindValue="merchant_id"
					[searchFn]="merchantSearchFn"
					[clearable]="true"
					[placeholder]="t('ابحث بالاسم أو رقم الهوية أو رقم التاجر', 'Search by name, ID number, or merchant ID', 'חיפוש לפי שם, מספר מזהה, או מספר סוחר')"
					formControlName="merchant_id"
				>
					<ng-template ng-option-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
					<ng-template ng-label-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
				</ng-select>
			</div>
			<div class="col-md-6">
				<label class="form-label">{{ t('خطة الامتداد', 'Extension plan', 'תוכנית הרחבה') }} *</label>
				<select class="form-select" formControlName="plan_id">
					<option [ngValue]="null">{{ t('اختر الخطة', 'Select plan', 'בחר תוכנית') }}</option>
					<option *ngFor="let p of tokenExtensionPlans" [ngValue]="p.id">{{ getPlanOptionLabel(p) }} (#{{ p.id }})</option>
				</select>
			</div>
			<div class="col-md-6">
				<label class="form-label">{{ t('طريقة التفعيل', 'Activation Mode', 'מצב הפעלה') }}</label>
				<select class="form-select" formControlName="activation_mode">
					<option value="admin_grant">{{ t('تفعيل مباشر', 'Admin Grant', 'הפעלה ישירה') }}</option>
					<option value="payment_link">{{ t('رابط دفع', 'Payment Link', 'קישור תשלום') }}</option>
				</select>
			</div>
			<div class="col-md-6">
				<label class="form-label">{{ t('لغة الدفع', 'Payment Language', 'שפת תשלום') }}</label>
				<select class="form-select" formControlName="language">
					<option value="ar">Arabic</option>
					<option value="en">English</option>
					<option value="he">Hebrew</option>
				</select>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-outline-secondary" type="button" (click)="modal.dismiss()">
			{{ t('إغلاق', 'Close', 'סגור') }}
		</button>
		<button class="btn btn-dark" type="button" (click)="createMerchantTokenExtension()">
			{{ t('تنفيذ', 'Submit', 'שלח') }}
		</button>
	</div>
</ng-template>

<ng-template #planModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">
			{{ isEditingPlan ? t('تعديل خطة امتداد', 'Edit token extension plan', 'עריכת תוכנית הרחבת טוקנים') : t('إنشاء خطة امتداد', 'Create token extension plan', 'יצירת תוכנית הרחבת טוקנים') }}
		</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="planForm" class="row g-3">
			<div class="col-md-4">
				<label class="form-label">Name EN *</label>
				<input class="form-control" formControlName="name_en" />
				<div class="invalid-feedback d-block" *ngIf="isInvalid(planForm, 'name_en')">{{ t('مطلوب', 'Required', 'חובה') }}</div>
			</div>
			<div class="col-md-4">
				<label class="form-label">Name AR</label>
				<input class="form-control" formControlName="name_ar" />
			</div>
			<div class="col-md-4">
				<label class="form-label">Name HE</label>
				<input class="form-control" formControlName="name_he" />
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('عدد التوكنات الإضافية', 'Extra tokens', 'טוקנים נוספים') }} *</label>
				<input type="number" min="1" class="form-control" formControlName="extra_tokens" />
				<div class="invalid-feedback d-block" *ngIf="isInvalid(planForm, 'extra_tokens')">{{ t('رقم موجب مطلوب', 'Positive number required', 'נדרש מספר חיובי') }}</div>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('السعر', 'Price', 'מחיר') }} *</label>
				<input type="number" min="0.01" step="0.01" class="form-control" formControlName="price" />
				<div class="invalid-feedback d-block" *ngIf="isInvalid(planForm, 'price')">{{ t('سعر صحيح مطلوب', 'Valid price required', 'נדרש מחיר תקין') }}</div>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('الترتيب', 'Sort Order', 'סדר') }}</label>
				<input type="number" min="0" class="form-control" formControlName="sort_order" />
			</div>
			<div class="col-md-4">
				<label class="form-label">Description EN</label>
				<input class="form-control" formControlName="description_en" />
			</div>
			<div class="col-md-4">
				<label class="form-label">Description AR</label>
				<input class="form-control" formControlName="description_ar" />
			</div>
			<div class="col-md-4">
				<label class="form-label">Description HE</label>
				<input class="form-control" formControlName="description_he" />
			</div>
			<div class="col-md-4 d-flex align-items-center">
				<div class="form-check mt-4">
					<input class="form-check-input" type="checkbox" id="plan_active" formControlName="is_active" />
					<label for="plan_active" class="form-check-label">
						{{ t('خطة فعّالة', 'Plan Active', 'תוכנית פעילה') }}
					</label>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-dark" type="button" (click)="savePlan()">
			{{ isEditingPlan ? t('حفظ التعديل', 'Save Changes', 'שמירת שינויים') : t('إنشاء الخطة', 'Create Plan', 'יצירת תוכנית') }}
		</button>
		<button class="btn btn-outline-secondary" type="button" (click)="modal.dismiss()">
			{{ t('إلغاء', 'Cancel', 'ביטול') }}
		</button>
	</div>
</ng-template>
